import Backbone from "backbone";
import $ from "jquery";
import * as _ from "underscore";

import * as mustcache from "mustcache";

// Updates the model's "search" attribute after a short delay

// TODO: red border when invalid (e.g. less than 3 letters)
const SearchView = Backbone.View.extend({
  initialize: function () {
    this.render();
    this.searchDebounced = _.debounce((query) => {
      this.search(query);
    }, 500);
  },
  render: function () {
    mustcache.render("searchView", {}, (html) => {
      this.$el.html(html);
      if (this.model.get("query").length > 0) {
        this.$(".searchInput").val(this.model.get("query")).focus();
      }
    });
  },
  events: {
    "keyup .searchInput": "onKeyup",
    "click .searchButton": "searchButton",
  },
  onKeyup: function (event) {
    const query = $(event.target).val();
    if (event.which === 13 /* Enter */) {
      this.search(query);
    } else if (event.which === 27 /* ESC */) {
      this.$(".searchInput").val("");
      this.search("");
    } else {
      //this.searchDebounced(query);
    }
  },
  searchButton: function () {
    this.search(this.$(".searchInput").val());
  },
  search: function (query) {
    this.model.set("query", query);
  },
});

export default SearchView;
